


















































































import { TipoDeficiencia } from '@/model/tipo-deficiencia';
import { Component, Prop, Vue } from 'vue-property-decorator';
import tipoDeficienciaService from '@/api/tipo-deficiencia.service';
import { TipoDeficienciaFilter } from '@/model/filter/tipo-deficiencia-filter';
import Multiselect from 'vue-multiselect';

@Component
export default class TipoDeficienciaComponent extends Vue {

    @Prop() public isExibirProp!: Boolean;
    @Prop() public showCollapseProp!: Boolean;
    @Prop() public tiposDeficienciaProp!: Array<TipoDeficiencia>;

    public isExibir: Boolean = false;
    public showContent: Boolean = false;

    public tiposDeficienciaEspecifica: Array<TipoDeficiencia> = Array.of();
    public tiposDeficienciaGeral: Array<TipoDeficiencia> = Array.of();
    public tiposDeficienciaGeralSelecionadas: Array<TipoDeficiencia> = Array.of();
    public tiposDeficienciasSelecionadas: Array<TipoDeficiencia> = Array.of();

    public idsDeficienciaGeralSelecionadas: Set<number> = new Set()

    constructor () {
        super();
        this.$parent.$on('openFieldset', this.openFieldset);
        this.idsDeficienciaGeralSelecionadas = new Set()
        
        if (this.showCollapseProp != undefined) {
            this.showContent = this.showCollapseProp;
        }        
        this.tiposDeficienciasSelecionadas = this.tiposDeficienciaProp;
        this.tiposDeficienciasSelecionadas.forEach(selecionado => {
            if (selecionado.pai) {
                let idpai = selecionado.pai.id
                const index = this.tiposDeficienciaGeralSelecionadas.map(g => g.id).indexOf(selecionado.pai.id, 0);
                if (index == -1) {
                    //this.tiposDeficienciaGeralSelecionadas.push(selecionado.pai);
                    this.idsDeficienciaGeralSelecionadas.add(new Number(idpai).valueOf())
                }
            }
            else{
                const index = this.tiposDeficienciaGeralSelecionadas.map(g => g.id).indexOf(selecionado.id, 0);
                if (index == -1) {
                    //this.tiposDeficienciaGeralSelecionadas.push(selecionado.pai);
                    this.idsDeficienciaGeralSelecionadas.add(new Number(selecionado.id).valueOf())
                }
            }
        })
        /*if(this.tiposDeficienciaGeralSelecionadas.length == 0){
            this.tiposDeficienciaGeralSelecionadas = this.tiposDeficienciasSelecionadas
        }*/
        this.carregaTipoDeficiencia();
        this.atualizaDeficienciaEspecificas(new Set(this.idsDeficienciaGeralSelecionadas));
    }

    async carregaTipoDeficiencia() {
        let filtro = new TipoDeficienciaFilter("", true)
        filtro.gerais = true;
        filtro.subCategorias = true;
        
        const retorno = await tipoDeficienciaService.listarTiposDeficiencia(filtro, false);
        if (retorno != null){
            this.tiposDeficienciaGeral = retorno.registros;
        }
    }

    atualizaTiposDeficienciaEspecificas() {
        
        this.tiposDeficienciaEspecifica = Array.of()
        this.idsDeficienciaGeralSelecionadas = new Set()
        
        this.tiposDeficienciaGeralSelecionadas.forEach(geral => {
            this.idsDeficienciaGeralSelecionadas.add(new Number(geral.id).valueOf())
            if (geral.subCategorias) {
                geral.subCategorias.forEach(sub => this.tiposDeficienciaEspecifica.push(sub))
            }
        })

        if(this.tiposDeficienciaGeralSelecionadas.length == 0){
            this.tiposDeficienciasSelecionadas = Array.of()
            this.$emit('atualizarTiposDeficiencia')
        }
        else{
            let tiposRemover = Array.of()
            this.tiposDeficienciasSelecionadas.forEach(selecionado => {     
                //let encontrado = 0
                if(selecionado.pai && selecionado.pai != undefined){
                    let pai = selecionado.pai  
                    
                    
                    if(!this.idsDeficienciaGeralSelecionadas.has(new Number(pai.id).valueOf())){
                        let index = this.tiposDeficienciasSelecionadas.indexOf(selecionado, 0)
                        if(index > -1){
                            tiposRemover.push(selecionado)                            
                        }
                    }                 

                }
                
            })
            this.removerTiposDeficiencia(tiposRemover)
        }
    }
    
    removerTiposDeficiencia (tips) {
        if (this.tiposDeficienciasSelecionadas != null) {
            tips.forEach(tip => {     
                const index = this.tiposDeficienciasSelecionadas.indexOf(tip, 0);
                if (index > -1) {
                    this.tiposDeficienciasSelecionadas.splice(index, 1);
                    console.log("Removeu "+tip.descricao)
                }
            })
        }
    }

    removerTipoDeficiencia (tip: TipoDeficiencia) {
        if (this.tiposDeficienciasSelecionadas != null) {
            const index = this.tiposDeficienciasSelecionadas.indexOf(tip, 0);
            if (index > -1) {
                this.tiposDeficienciasSelecionadas.splice(index, 1);
            }
        }
    }

    public openFieldset(value) {
        if (this.$validator.errors.count() > 0) {
            this.showContent = value;
        }
    }

    atualizaDeficienciaEspecificas(gerals) {
        this.tiposDeficienciaEspecifica = Array.of()
        this.tiposDeficienciaGeralSelecionadas = Array.of()

        let gerais = new Set(gerals)

        gerais.forEach(idgeral => {
            let geral
            tipoDeficienciaService.obter(idgeral).then(resp => { 
                geral = resp
                const index = this.tiposDeficienciaGeralSelecionadas.map(g => g.id).indexOf(geral.id, 0);
                if (index == -1) {
                    this.tiposDeficienciaGeralSelecionadas.push(geral)                    
                }

                if (geral.subCategorias) {
                    geral.subCategorias.forEach(sub => this.tiposDeficienciaEspecifica.push(sub))                    
                }
            })
        })        
    }

}
